"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FilterInput = exports.Filter = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _input = _interopRequireDefault(require("@paprika/input"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var Filter = _styledComponents["default"].div.withConfig({
  displayName: "Filterstyles__Filter",
  componentId: "sc-12suo2d-0"
})(["padding:", ";position:relative;"], _tokens["default"].space);

exports.Filter = Filter;
var FilterInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "Filterstyles__FilterInput",
  componentId: "sc-12suo2d-1"
})(["&&{background-color:", ";}"], _tokens["default"].color.white);
exports.FilterInput = FilterInput;
//# sourceMappingURL=Filter.styles.js.map